import { Component, OnInit } from '@angular/core';
import {Edition, Warehouse} from '../../core/entities/entities';
import {WarehouseService} from '../../services/warehouse.service';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {NowComponentBase} from '../../shared/base/NowComponentBase';
import * as Rx from 'rxjs/Rx';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';

@Component({
  selector: 'app-price-rule-set-add',
  templateUrl: './price-rule-set-add.component.html',
  styleUrls: ['./price-rule-set-add.component.css']
})
export class PriceRuleSetAddComponent extends NowComponentBase implements OnInit {

  edition_search: EditiontQuery = {edition_name:'', type: 0};
  editions: Rx.Observable<Edition[]>;
  edition: Edition;


  ngOnInit() {

    this.editions = Rx.Observable.create((observer: any) => {
      observer.next(this.edition_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._editionServ.search({...term, brandId: this.brandId});
      });

    super.ngOnInit();
  }

  selectEdition(event: TypeaheadMatch) {
    if ( event && event.item ) {
      this.edition = event.item;
      this.edition_search.edition_name =  this.edition.name;
      this._editionServ.query = this.edition_search;
    }
  }

  eraseEdition() {
    this.edition_search.edition = null;
    this._editionServ.query = this.edition_search;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  constructor(private _editionServ: EditionService, private _router: Router) { super(); }

}



// WEBPACK FOOTER //
// ./src/app/conf/price-rule-set-add/price-rule-set-add.component.ts